import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ClockIcon } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set countdown to 24 hours from now
    const endTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToCheckout = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="compra" className="w-full bg-gradient-to-b from-blue-600 to-blue-800 py-16 md:py-20 px-4" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-122">
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-4 text-center" data-id="element-123">
            <div className="flex items-center justify-center gap-2 text-white" data-id="element-124">
              <ClockIcon className="w-5 h-5" data-id="element-125" />
              <p className="font-bold" data-id="element-126">Oferta especial termina en:</p>
            </div>
            <div className="flex justify-center gap-4 mt-3" data-id="element-127">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 min-w-[70px]" data-id="element-128">
                <div className="text-3xl font-bold text-white" data-id="element-129">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <div className="text-xs text-white/90" data-id="element-130">Horas</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 min-w-[70px]" data-id="element-131">
                <div className="text-3xl font-bold text-white" data-id="element-132">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <div className="text-xs text-white/90" data-id="element-133">Minutos</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 min-w-[70px]" data-id="element-134">
                <div className="text-3xl font-bold text-white" data-id="element-135">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <div className="text-xs text-white/90" data-id="element-136">Segundos</div>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-137">
            <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-138">
              <div className="flex-shrink-0 cursor-pointer" onClick={scrollToCheckout} data-id="element-139">
                <img src="https://cdn.magicpatterns.com/uploads/cJP3QLfTSi22hJWjmgPAzA/ChatGPT_Image_Jun_16,_2026,_12_26_18_PM.png" alt="Basquet 0 a Pro" className="w-full max-w-xs rounded-lg shadow-lg" data-id="element-140" />
              </div>

              <div className="flex-1" data-id="element-141">
                <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-142">
                  Basquet 0 a Pro
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-143">
                  Sistema completo de entrenamiento para jugadores amateurs de
                  16 a 30 años
                </p>

                <div className="space-y-3 mb-6" data-id="element-144">
                  <div className="flex items-start gap-2" data-id="element-145">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-146" />
                    <span className="text-gray-700" data-id="element-147">
                      6 módulos completos en PDF
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-148">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-149" />
                    <span className="text-gray-700" data-id="element-150">
                      4 bonos exclusivos (GRATIS hoy)
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-151">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-152" />
                    <span className="text-gray-700" data-id="element-153">
                      Plantillas editables en Google Sheets
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-154">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-155" />
                    <span className="text-gray-700" data-id="element-156">
                      Acceso inmediato y para siempre
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-157">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-158" />
                    <span className="text-gray-700" data-id="element-159">
                      Bono especial: Calculadora de proteínas para tus
                      entrenamientos
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-160">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-161" />
                    <span className="text-gray-700" data-id="element-162">
                      Bono especial 2: Calculadora de hidratación
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-163">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-164" />
                    <span className="text-gray-700" data-id="element-165">
                      Bono especial 3: Psicología deportiva
                    </span>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-6 mb-6" data-id="element-166">
                  <div className="flex items-center justify-between mb-2" data-id="element-167">
                    <span className="text-gray-500 line-through text-xl" data-id="element-168">
                      $55.900
                    </span>
                    <span className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-169">
                      -64% OFF
                    </span>
                  </div>
                  <div className="text-5xl font-bold text-blue-600 mb-1" data-id="element-170">
                    $19.990
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-171">
                    Precio especial solo por hoy
                  </p>
                </div>

                <a href="https://checkout.ebookpoint.shop/cart/59660259098705:1" className="block w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white text-center font-bold text-lg py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-172">
                  Quiero dominar la cancha
                </a>

                <p className="text-center text-sm text-gray-500 mt-4" data-id="element-173">
                  🔒 Pago seguro • Acceso inmediato
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}